import React, { createContext, useContext, useCallback } from "react";
import has_permission from "src/common/utils/permission";

type Action = "add" | "edit" | "delete" | "view" | "view_own";

type PermissionContextType = {
  can: (
    module: string,
    slug: string,
    action: Action | Action[]
  ) => boolean;
};

const PermissionContext = createContext<PermissionContextType | null>(null);

export const PermissionProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const can = useCallback(
    (module: string, slug: string, action: Action | Action[]) =>
      has_permission(module, slug, action),
    []
  );

  return (
    <PermissionContext.Provider value={{ can }}>
      {children}
    </PermissionContext.Provider>
  );
};

export const usePermission = () => {
  const ctx = useContext(PermissionContext);
  if (!ctx) {
    throw new Error("usePermission must be used inside PermissionProvider");
  }
  return ctx;
};
